import {Alert} from 'platform/components';
import {VStack} from 'platform/foundation';
import {useFormatNumber} from 'platform/locale';

import {useSyncExternalStore} from 'react';

import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {BulkOperationConfirmForm, type BulkOperationActionCallbackParams} from 'features/eag-grid';

export function InterestDeleteBulkForm(props: {action: BulkOperationActionCallbackParams}) {
  const context = props.action.context;
  const state = useSyncExternalStore(context.subscribe, context.getSnapshot);
  const formatNumber = useFormatNumber();
  const recordCount =
    state.scope === 'selected'
      ? state.selection.recordIds.length
      : (state.selection.query.totalCount ?? 0);
  const recordsLabel = i18n.t('entity.automationRule.testRun.actionUnit.record', {
    count: recordCount,
    formattedCount: formatNumber(recordCount, 0),
  });

  return (
    <VStack spacing={4}>
      <Alert
        variant="warning"
        title={i18n.t('general.actions.namedConfirmDeleteQuestion', {name: recordsLabel})}
        message={i18n.t('entity.newVehicle.catalogue.deleteRuleWarning')}
      />
      <BulkOperationConfirmForm action={props.action} onError={handleApiError} />
    </VStack>
  );
}
